import script from "./FluxTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FluxTable.vue?vue&type=script&setup=true&lang=js"

import "./FluxTable.vue?vue&type=style&index=0&id=25cf8426&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cf8426"]])

export default __exports__